/** Switch between `"current"` and `"magic-path"` to compare animation modes. */
export const GENIE_ANIMATION_MODE = "magic-path";

/** Major sections in scroll order. Hero stays static; travelling animation starts at Services. */
export const MAGIC_PATH_SECTIONS = [
    "#hero",
    "#services",
    "#how-it-works",
    "#why-reno-genie",
    "#showcase",
    "#cta",
];
